import React from 'react';
import GoogleSVG from '../assets/Google';
import config from '../utils/config';

const GoogleLoginButton = ({disabled}) => {
  const handleGoogleLogin = () => {
    window.location.href = `${config.apiBaseUrl}/auth/google`;
  };

  return (
    <button
      onClick={handleGoogleLogin}
      className="w-[250px] md:w-[300px] flex items-center justify-center gap-2 bg-white text-gray-700 border border-gray-300 rounded-md px-4 py-2 hover:bg-gray-50"
      disabled={disabled}
    >
      <GoogleSVG width={22} height={22}/>
      Continue with Google
    </button>
  );
};

export default GoogleLoginButton; 

// const GoogleLoginButton = ({disabled}) => {
//   const handleGoogleLogin = () => {
//     window.location.href = `${config.apiBaseUrl}/auth/google`;
//   };

//   return (
//     <button
//       onClick={handleGoogleLogin}
//       className="w-[250px] md:w-[300px] flex items-center justify-center gap-2 bg-white text-gray-700 border border-gray-300 rounded-md px-4 py-2 hover:bg-gray-50"
//       disabled={disabled}
//     >
//         <GoogleSVG width={22} height={22}/>
//       Continue with Google
//     </button>
//   );
// };